export const formatLinkBlockToUrl = (data) => {
    const linkTo = data?.linkTo;
    let url = '';
    switch (linkTo) {
        case 'email':
            url = 'mailto:' + data[linkTo];
            break;
        case 'anchor':
            url = '#' + data[linkTo];
            break;
        case 'custom_url':
            url = data?.customUrl;
            break;
        case 'file':
            url = data[linkTo]?.url;
            break;
        case 'page':
            url = data[linkTo]?.url;
            break;
        case 'phone':
            url = 'tel:' + data[linkTo];
            break;
    }

    return url;
};
